/**
 * LLM 调试日志配置
 * 说明：
 * - 开启后会输出原始返回内容（成功与失败）
 * - 关闭后仅保留错误摘要日志
 */
export const LLM_DEBUG_CONFIG = {
  /** Provider：是否打印发送前消息摘要（运行时/编译后） */
  PROMPT_MESSAGES_LOG_ENABLED: false,
  /** Provider：是否打印提示词编译追踪（世界书命中等） */
  PROMPT_COMPILE_TRACE_LOG_ENABLED: false,
  /** MessagePipeline：是否打印完整链路追踪（runtime/compiled） */
  MESSAGE_PIPELINE_TRACE_LOG_ENABLED: false,
  /** MessagePipeline：是否打印运行时链路（关闭后仅打印“预设编译后”） */
  MESSAGE_PIPELINE_TRACE_RUNTIME_LOG_ENABLED: false,
  /** 任务驱动据点：是否在“落库完成”日志中附带完整 LLM 三段链路（提示词+原始输出） */
  QUEST_DRIVEN_PIPELINE_FULL_LOG_ENABLED: false,
  /** 通用 LLMClient：是否打印原始输出 */
  LLM_CLIENT_RAW_OUTPUT_LOG_ENABLED: false,
  /** 角色生成：是否打印原始输出 */
  CHARACTER_RAW_OUTPUT_LOG_ENABLED: true,
  /** 物品生成：是否打印原始输出 */
  ITEM_RAW_OUTPUT_LOG_ENABLED: true,
  /** 技能生成：是否打印原始输出 */
  SKILL_RAW_OUTPUT_LOG_ENABLED: true,
  /** 世界生成：是否打印原始输出 */
  WORLD_RAW_OUTPUT_LOG_ENABLED: true,
  /** 任务生成：是否打印原始输出 */
  QUEST_RAW_OUTPUT_LOG_ENABLED: true,
  /** 任务绑定生成：是否打印原始输出 */
  QUEST_BINDING_RAW_OUTPUT_LOG_ENABLED: true,
} as const;
